import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, ColumnSeries, Category, DataLabel, Tooltip, Legend } from '@syncfusion/ej2-react-charts';
import { PMCenterBreakdownView } from '../../../../services/ReportingService';

interface PMByCenterChartProps {
  centerData: PMCenterBreakdownView[];
}

const PMByCenterChart: React.FC<PMByCenterChartProps> = ({ centerData }) => {
  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
          PMs by Location
        </Typography>
        {centerData.length > 0 ? (
          <ChartComponent
            id="pm-by-center"
            primaryXAxis={{ valueType: 'Category' }}
            primaryYAxis={{ title: 'Count' }}
            tooltip={{ enable: true }}
            height="300px"
          >
            <Inject services={[ColumnSeries, Category, DataLabel, Tooltip, Legend]} />
            <SeriesCollectionDirective>
              <SeriesDirective
                dataSource={centerData}
                xName="centerName"
                yName="completedCount"
                type="Column"
                name="Completed"
                fill="#10b981"
              />
              <SeriesDirective
                dataSource={centerData}
                xName="centerName"
                yName="overdueCount"
                type="Column"
                name="Overdue"
                fill="#f59e0b"
              />
            </SeriesCollectionDirective>
          </ChartComponent>
        ) : (
          <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="body2" color="#64748b">
              No data available
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default PMByCenterChart;
